export default "__VITE_ASSET__D709s9Va__"